import LoginForm from '../../components/login/LoginForm';
import './LoginPortal.scss';

const LoginPortal = (props) => (
  <LoginForm {...props} />
);

export default LoginPortal;
